<template>
  <div class="root-stats">
    <!--  <div class="tabk">-->

    <div class="main-nav styleCard">
      <ul class="style-nav style1">
        <li
          v-for="tab in statTabs"
          :key="tab.id"
          class="router-link"
          @click="selectedStatTab = tab.alias"
          :class="{ active: selectedStatTab === tab.alias }"
        >
          {{ tab.name }}
        </li>
      </ul>
    </div>

    <!--      <button
        v-for="tab in statTabs"
        :key="tab.id"
        :class="{ active: selectedStatTab === tab.alias }"
        @click="selectedStatTab = tab.alias"
      >
        {{ tab.name }}
      </button>
    </div>-->
    <viki-msg-stats v-if="selectedStatTab === 'MSG_STATS'"></viki-msg-stats>
    <reports v-if="selectedStatTab === 'REPORTS'"></reports>
    <stats v-if="selectedStatTab === 'STATS'"></stats>
    <!--    <misc v-if="selectedStatTab === 'MISC'"></misc>-->
    <total-stats v-if="selectedStatTab === 'TOTAL_STATS'"></total-stats>
    <total-stats-users
      v-if="selectedStatTab === 'TOTAL_STATS_USERS'"
    ></total-stats-users>
    <cost-stats v-if="selectedStatTab === 'COSTS'"></cost-stats>
    <avg v-if="selectedStatTab === 'AVG_CHARTS'"></avg>
    <retention v-if="selectedStatTab === 'RET_CHART'"></retention>
    <stats-redo v-if="selectedStatTab === 'STATS_REDO'"></stats-redo>
  </div>
</template>

<script>
import VikiMsgStats from "./VikiMsgStats.container";
//import Reports from "../containers/Reports.container";
import Reports from "../reports.sub_feature/containers/Reports.container";
import Stats from "../stats.sub_feature/containers/Stats.container";
import StatsRedo from "../statsRedo.sub_feature/containers/StatsRedo.container";
// import Misc from "../misc.sub_feature/containers/Misc.container";
import TotalStats from "../total_stats.sub_feature/containers/TotalStats.container";
import Avg from "../graph_sub_feature/containers/Avg.container";
import Retention from "../graph_sub_feature/containers/Retention.container";
import CostStats from "../costs.sub_feature/containers/CostStats.container";
import TotalStatsUsers from "../total_stats_users.sub_feature/containers/TotalStatsUsers.container";
export default {
  name: "Statistics.container",

  components: {
    StatsRedo,
    TotalStatsUsers,
    CostStats,
    TotalStats,
    // Misc,
    VikiMsgStats,
    Reports,
    Stats,
    Avg,
    Retention
  },
  data() {
    return {
      selectedStatTab: "MISC",
      statTabs: [
        {
          id: 0,
          name: "Msg Statistics",
          alias: "MSG_STATS"
        },
        {
          id: 1,
          name: "Reports",
          alias: "REPORTS"
        },
        {
          id: 2,
          name: "Statistics",
          alias: "STATS"
        },
        // {
        //   id: 3,
        //   name: "Misc",
        //   alias: "MISC"
        // },
        {
          id: 3,
          name: "Total Stats",
          alias: "TOTAL_STATS"
        },
        {
          id: 4,
          name: "Total Stats Users",
          alias: "TOTAL_STATS_USERS"
        },
        {
          id: 5,
          name: "Costs",
          alias: "COSTS"
        },
        {
          id: 6,
          name: "Avg Charts",
          alias: "AVG_CHARTS"
        },
        {
          id: 7,
          name: "Auto Removal Clients",
          alias: "RET_CHART"
        },
        {
          id: 8,
          name: "Statistics Redo",
          alias: "STATS_REDO"
        }
      ]
    };
  },
  beforeMount() {
    this.$store.dispatch("clients/getGeneralDictionary").then(res => {
      this.$store.dispatch("clients/getActivityDictionary").then(res => {
        this.$store.dispatch("clients/getSalesPersonList").then(res => {});
      });
    });
  },
  watch: {
    selectedStatTab: function() {
      if (this.selectedStatTab === "MSG_STATS") {
      }
      if (this.selectedStatTab === "REPORTS") {
      }
      if (this.selectedStatTab === "STATS") {
      }
    }
  }
};
</script>

<style scoped>
.styleCard {
  font-family: Montserrat, serif;
  box-shadow: 0 9px 20px rgba(0, 0, 0, 0.05);
  border-radius: 5px;
}
.main-nav {
  display: flex;
  flex-direction: column;
  border-radius: 0;
  background: white;
  margin-top: 0.3rem !important;
}
.style-nav {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  position: relative;
}
/*
  .style-nav.style2 li{
      border-radius: 5px 5px 0px 0px;
      transition:transform 0.1s ease;
  }
  .style-nav.style2 li:not(:last-child){
      margin-right:2px;
  }
  */

.style-nav .router-link {
  max-width: 150px;
  min-width: 72px;
  height: 28px;
  margin: 0;
  cursor: pointer;
  background: white;
  border-radius: 0;
  font-size: 11px;
  color: black;
  text-align: center;
  vertical-align: middle;
  line-height: 28px;
  border-bottom: 2px solid transparent;
  flex-grow: 1;
  transition: background 0.3s ease, color 0.3s ease;
}

.style-nav.style2 li:not(.empty):hover {
  transform: translateY(5px);
}

.style-nav.style2 li.active {
  border-bottom: 2px solid #44a2d2 !important;
  color: #44a2d2;
}

.style-nav.style1 .router-link:not(.empty):hover {
  background: #44a2d2;
  color: white;
  text-decoration: none;
}

.style-nav.style1 .router-link.active {
  border-bottom: 2px solid #44a2d2 !important;
  background: #44a2d2;
  color: white;
  text-decoration: none;
}
.inter-time-container {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}
.inter-time-container span:first-child {
  margin-bottom: 0.2rem;
  display: block;
}
.inter-time-container span {
  font-size: 10px;
  font-weight: bold;
}

.inter-time img {
  margin-left: 5px;
  margin-right: 7px;
  position: relative;
  top: 1px;
}
.inter-time {
  width: 80px;
  display: inline-block;
  height: 100%;
  vertical-align: top;
  line-height: 14px;
}
.profile-avatar {
  width: 40px;
  display: inline-block;
  height: 100%;
  position: relative;
}
.profile-part {
  border-left: 2px solid #eff3f6;
}
.profile-avatar img {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  border-radius: 50%;
}
.profile-dropdown {
  left: -210px;
  padding: 10px;
  width: 250px;
  text-align: center;
}

.bttn {
  width: 100%;
  margin-top: 0.5rem;
  background: #44a2d2;
  color: white;
  border: 0;
  border-radius: inherit;
  padding: 5px;
  font-size: 12px;
  font-family: inherit;
  cursor: pointer;
}
.author-card img {
  margin-bottom: -10px;
  margin-top: 20px;
}

/*.root-stats {
  height: 100%;
}

.tabk {
  float: left;
  background-color: #f1f1f1;
  height: 100%;
}

.tabk button {
  display: block;
  font-size: 8pt;
  background-color: inherit;
  color: black;
  padding: 22px 16px;
  width: 100%;
  height: 30px;
  border: none;
  outline: none;
  text-align: left;
  cursor: pointer;
  transition: 0.2s;
  line-height: 8pt;
}

.tabk button.active {
  border-bottom: 2px solid #44a2d2 !important;
  background: #44a2d2;
  color: white;
  width: 107%;
  border-bottom-right-radius: 5px;
  border-top-right-radius: 5px;
}

.tabk button:hover {
  background: #44a2d2;
  color: white;
  width: 107%;
  border-bottom-right-radius: 5px;
  border-top-right-radius: 5px;
}

.tabk span {
  font-size: 8pt;
  font-weight: normal;
}*/
</style>
